import { render, staticRenderFns } from "./Closings.vue?vue&type=template&id=01f32257"
import script from "./Closings.vue?vue&type=script&lang=js"
export * from "./Closings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports